import ResultsCompany from './resultsCompany.js';
export default ResultsCompany;
